module.exports = __webpack_public_path__ + "assets/img/chartCard-up.1c819e9d.svg";